import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import axios from "axios";
import $ from "jquery";
import { MDBTableEditable } from "../_mdbcomponents/components/pro/TableEditable/TableEditable";
import { MDBCard } from "../_mdbcomponents/components/Card/Card";
import { MDBCardHeader } from "../_mdbcomponents/components/Card/CardHeader/CardHeader";
import { MDBCardBody } from "../_mdbcomponents/components/Card/CardBody/CardBody";
import { TriageSidebar } from "../Layouts/TriageSidebar";
import { Preview, print } from "react-html2pdf";
import { MDBDataTable } from "../_mdbcomponents/components/DataTable/DataTable";
import Loader from "../Layouts/Loader";
import TheatreSidebar from "../Layouts/TheatreSidebar";

export class PostOpObservationScare2 extends Component {
  constructor(props) {
    super(props);

   

    const url = "";
    this.state = {
      ObservationsCare2Time: "",
      AirwayETTRemoved: "",
      WoundClosureChecked: "",
      Bleeding: "",
      WoundPacksRemoved: "",
      DrainsPresent: "",
      ImplantsPresent: "",
      XRaysPresent: "",
      myParentTrigger: "",
      patientName: localStorage.getItem("currentVisitName"),
      tablevaluesglobal: {},
      loading: false,
      Datetime:""
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.PrintWindow = this.PrintWindow.bind(this);
    this.modal = true;
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  componentDidMount() {
    $(".yesSelected").click(function () {
      $(".hiddenPart").show();
    });
    $(".noSelected").click(function () {
      $(".hiddenPart").hide();
    });
  }

  proceedEvent(event) {
    window.location.href = "/theatre/recovery/room/handover";
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  onTableChange(event) {}

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("visitId"),
      surgeryid: localStorage.getItem("surgeryid"),
    };

    console.log(headers);

    event.preventDefault();
    console.log(localStorage.getItem("objectLength"));
    var objectLength = localStorage.getItem("objectLength");

    this.setState({
      Year: this.state.tablevaluesglobal[0]["Year"],
      loading: true
    });

    console.log(this.state);

    for (var i = 0; i < Object.keys(this.state.tablevaluesglobal).length; i++) {
      // console.log(this.state.tablevaluesglobal[i]['Year'])

      var dict = {
        ObservationsCare2Time:
          this.state.tablevaluesglobal[i]["ObservationsCare2Time"],
        AirwayETTRemoved: this.state.tablevaluesglobal[i]["AirwayETTRemoved"],
        WoundClosureChecked:
          this.state.tablevaluesglobal[i]["WoundClosureChecked"],
        Bleeding: this.state.tablevaluesglobal[i]["Bleeding"],
        WoundPacksRemoved: this.state.tablevaluesglobal[i]["WoundPacksRemoved"],
        DrainsPresent: this.state.tablevaluesglobal[i]["DrainsPresent"],
        ImplantsPresent: this.state.tablevaluesglobal[i]["ImplantsPresent"],
        XRaysPresent: this.state.tablevaluesglobal[i]["XRaysPresent"],
        Datetime: this.state.tablevaluesglobal[i]["Datetime"]
      };

      axios
        .post(
          this.api_url+"optheatre/operativeorders/post/labour/observationscare2",
          dict,
          { headers: headers }
        )
        .then((response) => {
          console.log(response);
          // /triage/antenatal/history
          this.setState({
            loading: false
          })
          if (response.data) {
            console.log(headers);
            axios
              .post(
                this.api_url+"/optheatre/operativeorders/post/labour/observationscare2",
                { headers: headers }
              )
              .then((response) => {
                console.log(response);
                let table = response.data;
                console.log(table);
                let object = {};
                for (let i = 0; i < table.length; i++) {
                  delete table[i]._id;
                  delete table[i].timeOfRegistration;
                  table[i].clickEvent = () => this.handleRowClick(table[i]);
                }
                // table = JSON.stringify(table);
                this.TableData = table;
                console.log(this.TableData);
                this.setState({
                  DataLoaded: true,
                });
              })
              .catch((error) => {
                console.log(error);
              });

            if (response.data["status"]) {
              $(".alert-success").show();
              setTimeout(function () {
                // alert('sdsd')
                $(".HistoryModal").show();
              }, 1500);
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  handleTableChange(event) {
    // console.log(event);
    // this.setState({ myParentTrigger: this.state.myParentTrigger + 'a' });
  }

  formatTableOutput(data) {
    let topobj = {};
    let tableobj = {};
    for (let i = 0; i < data.length; i++) {
      let trim = data[i];
      let trimobj = {};
      this.setState({
        Year: "1212",
      });

      trimobj.ObservationsCare2Time = data[i][0];
      trimobj.AirwayETTRemoved = data[i][1];
      trimobj.WoundClosureChecked = data[i][2];
      trimobj.Bleeding = data[i][3];
      trimobj.WoundPacksRemoved = data[i][4];
      trimobj.DrainsPresent = data[i][5];
      trimobj.ImplantsPresent = data[i][6];
      trimobj.XRaysPresent = data[i][7];
      trimobj.Datetime = data[i][7];
      tableobj[i] = trimobj;
      topobj.prepplan = tableobj;
    }
    this.state.tablevaluesglobal = topobj["prepplan"];
  }

  getTableValues(event) {
    // console.log('entns');
    // console.log(event);
    let tablevalues = this.formatTableOutput(event);
    console.log(tablevalues);
  }

  render() {
    //Editable table variables
    const data = [
      ["", "", "", "", "", "", "", "",""],

      // ["4th", "", ""],
    ];

    const columns = [
      "ObservationsCare2Time",
      "AirwayETTRemoved",
      "WoundClosureChecked",
      "Bleeding",
      "WoundPacksRemoved",
      "DrainsPresent",
      "ImplantsPresent",
      "XRaysPresent",
      "Datetime",
    ];

    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left" };
    const displayHidden = { display: "none" };
    const width100 = { width: "100%" };
    const autoscroll = { overflowY: "auto" };
    // {""":{"date""12/12/2022", "result":"good"}, "2nd":{"date":12/12/2022"","result":"good"}}

    const {
      AttendedAntenatalCare,
      NumPreviousVisits,
      FaciltyPreviousVisits,
      AntiTetanusVaccination,
      NumPreviousVaccinations,
      LastVaccinationDate,
      AnteNatalHistoryPreviousObstetricUltrasound,
      AnteNatalHistoryNumPreviousUltrasound,
      AnteNatalHistoryTableTrimester,
      AnteNatalHistoryTableDate,
      PreviousFacilityVisitDate,
      AnteNatalHistoryTableResult,
      patientName,
    } = this.state;

    let { DataLoaded, loading } = this.state;
    const tabledata = {
      columns: [
        {
          label: "ObservationsCare2Time",
          field: "ObservationsCare2Time",
          sort: "asc",
          width: 50,
        },
        {
          label: "AirwayETTRemoved",
          field: "AirwayETTRemoved",
          sort: "asc",
          width: 50,
        },
        {
          label: "WoundClosureChecked",
          field: "WoundClosureChecked",
          sort: "asc",
          width: 50,
        },
        {
          label: "Bleeding",
          field: "Bleeding",
          sort: "asc",
          width: 50,
        },
        {
          label: "WoundPacksRemoved",
          field: "WoundPacksRemoved",
          sort: "asc",
          width: 50,
        },
        {
          label: "DrainsPresent",
          field: "DrainsPresent",
          sort: "asc",
          width: 50,
        },
        {
          label: "ImplantsPresent",
          field: "ImplantsPresent",
          sort: "asc",
          width: 50,
        },
        {
          label: "XRaysPresent",
          field: "XRaysPresent",
          sort: "asc",
          width: 50,
        },
        {
          label: "Datetime",
          field: "Datetime",
          sort: "asc",
          width: 50,
        },
      ],
      rows: this.TableData,
    };
    return (
      <div>
        <Headers />
        <TheatreSidebar />
        <main className="content-container ">
          <div className="container p-2">
            <form id="obsform" onSubmit={this.handleSubmit}>
              <MDBCard>
                <MDBCardHeader
                  tag="h3"
                  className="text-center font-weight-bold text-capitalise py-4"
                >
                  Post Operative Observations Care 2
                </MDBCardHeader>
                <MDBCardBody>
                  <MDBTableEditable
                    onChange={(value) => this.handleTableChange(value)}
                    getValue={(value) => this.getTableValues(value)}
                    myParentTrigger={this.state.myParentTrigger}
                    id="editablecard"
                    data={data}
                    columns={columns}
                    striped
                    bordered
                  />
                </MDBCardBody>
              </MDBCard>

              
              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                id="SubmitSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details were saved Successfuly.
              </div>
              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    {loading ? 'Loading' : 'Submit'}
                  </button>
                </div>
              </div>
              {/* <div className="alert alert-danger contactAdmin" style={displayHidden} role="alert">
                                <strong>Wait! </strong>Contact Administrator to get account approval.
                            </div> */}
            </form>
            <div className="modal  HistoryModal" tabIndex="-1" role="dialog">
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">
                      {" "}
                      {patientName}`s Post Operative Observations Care 2 Modal
                    </h5>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    {/* <div className="py-1">
                            <h6 className="text-capitalize" style={ fontFamilyNunito }>Name</h6><input className="form-control"   type="text" required/>
                        </div> */}
                    <br />
                    <br />
                    <br />
                    <a
                      className="btn btn-danger proceed"
                      onClick={this.proceedEvent}
                      style={width100}
                    >
                      Proceed to Next
                    </a>
                    <Preview id={"jsx-template"}>
                      <b>NAME: </b>
                      {patientName}

                      <MDBDataTable striped bordered data={tabledata} />
                    </Preview>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }
}

export default PostOpObservationScare2;
